import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import Intro from "../components/landing/Intro";
import ImpactStats from "../components/landing/ImpactStats";
import Services from "../components/landing/Services";
import MostRequested from "../components/landing/MostRequested";
import References from "../components/landing/References";
import Reviews from "../components/landing/Reviews";
import FinalCTA from "../components/landing/FinalCTA";
import Footer from "../components/landing/Footer";
import SEO from "../components/seo/SEO";
import { useLanguage } from "../i18n/LanguageContext";

export const HomePage = () => {
  const { lang } = useLanguage();
  return (
    <div data-testid="landing-page" className="bg-[#181B24] text-white">
      <SEO routeId="home" lang={lang} />
      <Header />
      <main>
        <Hero />
        <Intro />
        <ImpactStats />
        <Services />
        <MostRequested />
        <References />
        <Reviews />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
